import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiCatalogService} from "./api-catalog.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiCatalogService]
})
export class ApiCatalogModule { }
